import React from 'react';
import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useSelector, useDispatch} from 'react-redux';

import {Icon, stringUtils} from 'front-onceforall-core';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import appConfig from '../../../config';

import {recordGAEvent} from '../../utils/analytics';
import {VITRINE_ACCESSED} from '../../utils/constant';
import {getVitrineUrl} from '../../utils/path';
import {toggleModal} from '../../actions/modals';
import {toggleDiscoverVitrineBox} from '../../actions/display';

import {useDossierCountry} from '../organisationDashboard/OrganisationDashboardContainer';
import {pathResolver} from '../../utils/basePathHelper';

function DiscoverVitrineBox(props) {
  const dispatch = useDispatch();
  const [organisation = {}, isBoxShown] = useSelector(state => {
    const {organisationId} = state.organisation;
    const {showDiscoverVitrineBox = false} = state.display?.[organisationId] || {};
    return [state.organisation, showDiscoverVitrineBox];
  });
  const dossierCountry = useDossierCountry();

  const url = React.useMemo(() => getVitrineUrl(organisation.organisationId), [organisation.organisationId]);

  if (
    !appConfig?.featureFlags?.showAccessVitrineButton ||
    !isBoxShown ||
    !organisation.depositor ||
    !organisation.enabled ||
    dossierCountry !== COUNTRY.FRANCE
  ) {
    return null;
  }

  function gaEventOpenedModal() {
    recordGAEvent('Vitrine', `Opened Vitrine modal from ${props.dashboard ? 'Dashboard' : 'Documents'}`);
  }

  function gaEventHideBox() {
    recordGAEvent('Vitrine', `Hide discover Vitrine box on ${props.dashboard ? 'Dashboard' : 'Documents'}`);
  }

  function gaEventAccess() {
    recordGAEvent('Vitrine', `Accessed Vitrine from ${props.dashboard ? 'Dashboard' : 'Documents'}`);
  }

  const displayConfirmButton = () => {
    if (localStorage.getItem(VITRINE_ACCESSED)) {
      return (
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="large primary inline-container"
          href={url}
          onClick={gaEventAccess}
        >
          <Translate value="vitrine.discover.cta"/>
        </a>
      );
    }
    return (
      <button
        type="button"
        className="large primary inline-container"
        onClick={() => {
          dispatch(toggleModal('accessVitrineModal', true));
          gaEventOpenedModal();
        }}
      >
        <Translate value="vitrine.discover.cta"/>
      </button>
    );
  };

  return (
    <div className='background-white p-4 mx-0 my-5 row align-items-center'>
      <div className="col-1 d-flex flex-row justify-content-center">
        <img
          alt="logo vitrine"
          src={pathResolver('resources/img/icon_vitrine.png')}
          style={{maxWidth: '50px'}}
        />
      </div>
      <div className="col-9 d-flex flex-column align-items-center">
        {stringUtils.getStrongs(I18n.t('vitrine.discover.text1'))}
        {I18n.t('vitrine.discover.text2')}
      </div>
      <div className="col-2 d-flex flex-row justify-content-between">
        {displayConfirmButton()}
        <button
          type="button"
          onClick={() => {
            dispatch(toggleDiscoverVitrineBox(organisation.organisationId));
            gaEventHideBox();
          }}
        >
          <Icon
            tooltip={I18n.t('vitrine.discover.cancel')}
            icon="rounded-cross"
            size={25}
          />
        </button>
      </div>
    </div>
  );
}

DiscoverVitrineBox.defaultProps = {
  dashboard: false
};

DiscoverVitrineBox.propTypes = {
  dashboard: PropTypes.bool
};

export default DiscoverVitrineBox;
